import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconBandsintownBrandedStyle0 = cosmosIconCss;

const CosmosIconBandsintownBranded$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconBandsintownBranded extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '6cb59c9d4b673bc11cc2918b2fb164e10f261cdf', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '0ec95e817ee7f06b36ec2cf55d76ca36e5048f4e', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '24c45567a79acac7f90365279ea61be4088e5d4c', d: "M4.5 17.88V4h2.69v11.346h7.632v-.743H7.958v-2.536h9.553v5.813H4.5Z", fill: "#00CEC8" }), h("path", { key: 'a031d53ac584f46e4a2b9bb2708d8745c7fec882', d: "M14.822 4h2.664v7.12h-2.664V4Zm-3.561 3.74h2.664v3.381h-2.664V7.739Zm-.715 0H7.882v3.381h2.664V7.739Z", fill: "#00CEC8" }))));
    }
    static get style() { return CosmosIconBandsintownBrandedStyle0; }
}, [1, "cosmos-icon-bandsintown-branded", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-bandsintown-branded"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-bandsintown-branded":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconBandsintownBranded$1);
            }
            break;
    } });
}

const CosmosIconBandsintownBranded = CosmosIconBandsintownBranded$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconBandsintownBranded, defineCustomElement };
